export enum Routes {
	root = '/',
	home = '/home',
	roulette = '/roulette',
	activity = '/activity',
	settings = '/settings'
}
